import { Wrapper } from "AppReact";
import styled, { css } from "styled-components";

const template = styled.div`
  ${({ displayState }) => css`
    height: 24px;
    padding-left: 5px;
    padding-right: 3px;
    margin-left: 4px;

    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    
    cursor: pointer;
    border-radius: 20px;
    font-size: 12px;

    color: ${displayState?.color ??
    window?.settings?.primary_color ??
    "#1DBD6B"};
    background-color: ${displayState?.color
      ? `${displayState?.color}1A`
      : `${window?.settings?.primary_color ?? "#1DBD6B"}1A`};
  `}
`;

export default Wrapper(template);
